class Envira_Link {

    constructor( data, images, lightbox) {

        var self = this;

		//Setup our Vars
		self.data = data;
		self.images = images;
		self.id = this.get_config('gallery_id');
		self.envirabox_config = lightbox;

		//Log if ENVIRA_DEBUG enabled
		self.log(self.data);
		self.log(self.images);
		self.log(self.envirabox_config);
		self.log(self.id);

        self.init();

    }

    init() {

		var self = this;

		self.lightbox();

    }

	/**
	 * Outputs the gallery init script in the footer.
	 *
	 * @since 1.7.1
	 */
	lightbox() {

		var self            = this,
			touch           = self.get_config('mobile_touchwipe') ? { vertical: true, momentum: true } : false,
			thumbs          = self.get_config('thumbnails') ? { autoStart: true, hideOnClose: true, position: self.get_lightbox_config('thumbs_position') } : false,
			slideshow       = self.get_config('slideshow') ? { autoStart: self.get_config('autoplay'),speed: self.get_config('ss_speed') } : false,
			fullscreen      = self.get_config('fullscreen') && self.get_config('open_fullscreen') ? { autoStart: true } : true,
			animationEffect  = self.get_config('lightbox_open_close_effect') == 'zomm-in-out' ? 'zoom-in-out' : self.get_config('lightbox_open_close_effect'),
			transitionEffect = self.get_config('effect') == 'zomm-in-out' ? 'zoom' : self.get_config('effect'),
			lightbox_images  = [];
			self.lightbox_options = {
				selector:           '[data-envirabox="' + self.id + '"]',
				loop:               self.get_config('loop'), // Enable infinite gallery navigation
				margin:             self.get_lightbox_config('margins'), // Space around image, ignored if zoomed-in or viewport width is smaller than 800px
				gutter:             self.get_lightbox_config('gutter'), // Horizontal space between slides
				keyboard:           self.get_config('keyboard'), // Enable keyboard navigation
				arrows:             self.get_lightbox_config('arrows'), // Should display navigation arrows at the screen edges
				arrow_position:     self.get_lightbox_config('arrow_position'),
				infobar:            self.get_lightbox_config('infobar'), // Should display infobar (counter and arrows at the top)
				toolbar:            self.get_lightbox_config('toolbar'), // Should display toolbar (buttons at the top)
				idleTime:           60, // Detect "idle" time in seconds
				smallBtn:           self.get_lightbox_config('show_smallbtn'),
				protect:            false, // Disable right-click and use simple image protection for images
				image:              { preload: false },
				animationEffect:    animationEffect,
				animationDuration:  300, // Duration in ms for open/close animation
			    btnTpl : {
			        smallBtn   :        self.get_lightbox_config('small_btn_template'),
				},
				zoomOpacity:        'auto',
				transitionEffect:   transitionEffect, // Transition effect between slides
				transitionDuration: 200, // Duration in ms for transition animation
				baseTpl:            self.get_lightbox_config('base_template'), // Base template for layout
				spinnerTpl:         '<div class="envirabox-loading"></div>', // Loading indicator template
				errorTpl:           self.get_lightbox_config('error_template'), // Error message template
				fullScreen:         self.get_config('fullscreen') ? fullscreen : false,
				touch:              touch, // Set `touch: false` to disable dragging/swiping
				hash:               false,
				insideCap:          self.get_lightbox_config('inner_caption'),
			    media : {
			        youtube : {
			            params : {
			                autoplay : 0
			            }
			        }
			    },
			    wheel:              self.get_config('mousewheel') ? 'auto' : false,
				slideShow:          slideshow,
				thumbs:             thumbs,
		        mobile : {
		            clickContent : function( current, event ) {
		                return current.type === 'image' ? 'toggleControls' : false;
		            },
		            clickSlide : function( current, event ) {
		                return current.type === 'image' ? 'toggleControls' : 'close';
		            },
		            dblclickContent : false,
		            dblclickSlide :false,
		        },
				// Clicked on the content
				clickContent: false,
				clickSlide: 'toggleControls', // Clicked on the slide
				clickOutside: 'close', // Clicked on the background (backdrop) element

		        // Same as previous two, but for double click
		        dblclickContent : false,
		        dblclickSlide   : false,
		        dblclickOutside : false,

				// Callbacks
				//==========
				onInit: function(instance, current) {

					$( document ).trigger( 'envirabox_api_on_init', [ self, instance, current ]  );
				},

				beforeLoad: function(instance, current) {

					$(document).trigger('envirabox_api_before_load', [ self, instance, current ]  );

				},
				afterLoad: function(instance, current) {

					$(document).trigger('envirabox_api_after_load', [ self, instance, current ]  );

				},

				beforeShow: function(instance, current) {

					$(document).trigger('envirabox_api_before_show', [ self, instance, current ]  );

				},
				afterShow: function(instance, current) {

					if ( prepend == undefined || prepend_cap == undefined){

						var prepend     = false,
							prepend_cap = false;

					}

					if ( prepend != true ){

						$('.envirabox-position-overlay').each(function(){
							$(this).prependTo( current.$content );
						});

						prepend = true;
					}

					/* support older galleries or if someone overrides the keyboard configuration via a filter, etc. */
					
					if( self.get_config('keyboard') !== undefined && self.get_config('keyboard') === 0 ) {

						$(window).keypress(function(event){

						    if([32, 37, 38, 39, 40].indexOf(event.keyCode) > -1) {
						        event.preventDefault();
						    }

						});

					}

					/* legacy theme we hide certain elements initially to prevent user seeing them for a second in the upper left until the CSS fully loads */
					$('.envirabox-caption').show();
					$('.envirabox-navigation').show();
					$('.envirabox-navigation-inside').show();

					$(document).trigger('envirabox_api_after_show', [ self, instance, current ] );

				},

				beforeClose: function(instance, current) {

					$(document).trigger('envirabox_api_before_close', [ self, instance, current ]  );

				},
				afterClose: function(instance, current) {

					$(document).trigger('envirabox_api_after_close', [ self, instance, current ]  );

				},

				onActivate: function(instance, current) {

					$( document ).trigger('envirabox_api_on_activate', [ self, instance, current ] );

				},
				onDeactivate: function( instance, current ) {

					$( document ).trigger('envirabox_api_on_deactivate', [ self, instance, current ] );

				},

			};

		$(document).trigger( 'envirabox_options', self );

		// Mobile Overrides
		if ( self.is_mobile() ){

			if ( self.get_config('mobile_thumbnails') !== 1 ) {
				self.lightbox_options.thumbs = false;
			}

		}

		$.each( self.images, function(i){

			lightbox_images.push( this );

			/* is video? */
			
			var video_defaults = {
				youtube : {
					matcher : /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
					paramPlace : 8,
					type  : 'iframe',
					url   : '//www.youtube.com/embed/$4',
					thumb : '//img.youtube.com/vi/$4/hqdefault.jpg'
				},

				vimeo : {
					matcher : /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
					paramPlace : 3,
					type : 'iframe',
					url : '//player.vimeo.com/video/$2'
				},

				metacafe : {
					matcher : /metacafe.com\/watch\/(\d+)\/(.*)?/,
					type    : 'iframe',
					url     : '//www.metacafe.com/embed/$1/?ap=1'
				},

				dailymotion : {
					matcher : /dailymotion.com\/video\/(.*)\/?(.*)/,
					type : 'iframe',
					url  : '//www.dailymotion.com/embed/video/$1'
				},
				
				instagram : {
					matcher : /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
					type    : 'image',
					url     : '//$1/p/$2/media/?size=l'
				},

			};

			var media = $.extend( true, {}, video_defaults );
			var url = this.link;

			// Look for any matching media type
			$.each(media, function ( n, el ) {
				
				var rez = url.match(el.matcher);

				if (!rez) {
					return;
				}

				this.video = true;
				this.src = this.link;

			});



			console.log('pushing');
			console.log(this);

		});

		console.log(self.id);
		console.log('self.id');

        $('#envira-links-' + self.id ).on( 'click', function(e){

	        e.preventDefault();
			e.stopPropagation();

			var $this               = $( this ),
				images              = [],
				$envira_images      = $this.data('gallery-images'),
				sorted_ids          = $this.data('gallery-sort-ids'), // sort by sort ids, not by output of gallery-images, because retaining object key order between unserialisation and serialisation in JavaScript is never guaranteed.
				sorting_factor      = sorted_ids !== undefined && self.data.gallery_sort == 'gallery' ? 'id' : 'image',
				sorting_factor_data = sorted_ids !== undefined && self.data.gallery_sort == 'gallery' ? sorted_ids : $envira_images,				
				active              = $.envirabox.getInstance();


				// backup plan in case there isn't sorted_ids, we keep the lightbox_images even though this is probably not sorted
				if ( sorted_ids !== undefined && sorted_ids != '' ) {

					lightbox_images = [];

					$.each( sorted_ids, function( i, val ){
						lightbox_images.push( sorting_factor_data[val] );
					});

				}

				if ( active ) {
					console.log('envirabox.getInstance ACTIVE');
					return;
				}

			console.log('lightbox_images');
			console.log(lightbox_images);

			$.envirabox.open( lightbox_images, self.lightbox_options );

        });




	}

	/**
	 * Get a config option based off of a key.
	 *
	 * @since 1.7.1
	 */
	get_config(key) {

		var self = this;

		return self.data[key];

	}

	/**
	 * Helper method to get config by key.
	 *
	 * @since 1.7.1
	 */
	get_lightbox_config(key) {

		var self = this;

		return self.envirabox_config[key];

	}

	/**
	 * Helper method to get image from id
	 *
	 * @since 1.7.1
	 */
	get_image(id) {

		var self = this;

		return self.images[id];

	}
	is_mobile(){
		if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
			return true;
		}
		return false;
	}
	/**
	 * Helper method for logging if ENVIRA_DEBUG is true.
	 *
	 * @since 1.7.1
	 */
	log(log) {

		//Bail if debug or log is not set.
		if (envira_gallery.debug == undefined || !envira_gallery.debug || log == undefined) {

			return;

		}
		console.log(log);

	}

}

module.exports = Envira_Link;


// WEBPACK FOOTER //
// ./assets/js/gallery-link.js